import React from 'react';
import { Grid } from '@mui/material';
import SectionCard from '../inventory/components/SectionCard';
import { InvSelect, InvTextField } from '../inventory/components/InvField';
import ChargeServiceAutocomplete from './ChargeServiceAutocomplete';
import { OT_ROOM_CLASSIFICATION } from './otChargeApi';
import { OT_SECTION_SX } from './otTheme';

const DURATION_UNITS = [
  { value: 'minute', label: 'Minutes' },
  { value: 'hour', label: 'Hours' },
];

export default function OtRoomSection({
  room,
  onRoomChange,
  duration,
  onDurationChange,
  durationUnit,
  onDurationUnitChange,
}) {
  return (
    <SectionCard title="OT Room Selection" sx={OT_SECTION_SX}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <ChargeServiceAutocomplete
            label="OT Room"
            placeholder="Search OT rooms…"
            value={room}
            onChange={onRoomChange}
            classificationName={OT_ROOM_CLASSIFICATION}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <InvTextField
            label="Duration"
            type="number"
            value={duration}
            onChange={e => {
              const next = e.target.value;
              if (next === '') {
                onDurationChange('');
                return;
              }
              const n = Number(next);
              if (!Number.isFinite(n) || n < 0) return;
              onDurationChange(next);
            }}
            inputProps={{ min: 0, step: durationUnit === 'hour' ? 0.25 : 1 }}
          />
        </Grid>
        <Grid item xs={12} sm={3}>
          <InvSelect
            label="Unit"
            value={durationUnit}
            onChange={e => {
              const next = e.target.value;
              if (next === 'hour' || next === 'minute') onDurationUnitChange(next);
            }}
            options={DURATION_UNITS}
          />
        </Grid>
      </Grid>
    </SectionCard>
  );
}
